import { render } from "./SelecionarTipoPlanoAssinatura.vue?vue&type=template&id=7242a86a&ts=true"
import script from "./SelecionarTipoPlanoAssinatura.vue?vue&type=script&lang=ts"
export * from "./SelecionarTipoPlanoAssinatura.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__